<template>
  <v-data-table
    :headers="headers"
    :items="desserts"
    sort-by="calories"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Listado de encuentros a replanificar</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      v-model="editedItem.materia"
                      label="Materia"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      v-model="editedItem.nombreDocente"
                      label="Docente"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      v-model="editedItem.aula"
                      label="Aula/Laboratorio"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      v-model="editedItem.hora"
                      label="Horario"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-dialog
                      ref="dialog"
                      v-model="modal"
                      :return-value.sync="editedItem.fecha"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="editedItem.dia"
                          label="Fecha"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="editedItem.fecha" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal = false"
                          >Cancelar</v-btn
                        >
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.dialog.save(editedItem.fecha)"
                          >OK</v-btn
                        >
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn color="blue darken-1" text @click="save">Grabar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)">
        mdi-pencil
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">actualizar</v-btn>
    </template>
  </v-data-table>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    dialog: false,
    modal: false,
    headers: [
      {
        text: "Ref.",
        align: "start",
        sortable: false,
        value: "encuentroId",
      },
      { text: "Materia", value: "materia" },
      { text: "Docente", value: "nombreDocente" },
      { text: "Dia", value: "dia" },
      { text: "Hora", value: "hora" },
      { text: "Aula", value: "aula" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {},
    defaultItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Nuevo encuentro"
        : "Replanificar encuentro";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    editedItem: {
      handler(val) {
        val.fecha = this.formatDate(val.fecha);
        val.dia = this.formatDia(val.fecha);
      },
      deep: true,
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.obtenerEncuentros();
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("T")[0].split("-");
      return date.split("T")[0];
    },
    formatDia(date) {
      if (!date) return null;
      var datee = new Date(date + "T00:00:00");
      let fechiaaaa =
        datee.toLocaleDateString(undefined, { weekday: "long" }) +
        ", " +
        datee.toLocaleDateString(undefined, { day: "2-digit" }) +
        " de " +
        datee.toLocaleDateString(undefined, { month: "long" }) +
        " de " +
        datee.toLocaleDateString(undefined, { year: "numeric" });
      return fechiaaaa;
    },
    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      /* if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } */
      console.log(this.editedIndex ,this.editedItem);
      this.editedItem.estado=1;
      this.actualizarEncuentro();
      this.close();
    },
    actualizarEncuentro() {
      axios
        //.post("http://192.168.100.3:5000/api/v1/encuentro/cambiarEstado",this.editedItem)
        .post("http://pjleiva-001-site5.gtempurl.com/api/v1/encuentro/cambiarEstado",this.editedItem)
        .then((response) => {
          this.obtenerEncuentros();
        });
    },
    obtenerEncuentros() {
      axios
        //.get("http://192.168.100.3:5000/api/v1/encuentro/replanificar")
        .get("http://pjleiva-001-site5.gtempurl.com/api/v1/encuentro/replanificar")
        .then((response) => {
          this.desserts = response.data;
        });
    },
  },
  mounted() {
    this.obtenerEncuentros();
  },
};
</script>
